import React from 'react';
import classNames from 'classnames';

type WeekNumberProps = {
  active?: boolean;
} & React.JSX.IntrinsicElements['div']
const WeekNumber = (props: WeekNumberProps) => (
  <div className={'mui-calendar-cell-container'}  style={{ flex: '1 calc(100% / 8)', position: 'relative', justifyContent: 'center' }}>
    <div className={classNames(
      'mui-calendar-cell week-number',
      { 'week-number-active': props.active }
    )}
    {...props} />
  </div>
)
;

export default WeekNumber;
